import React from 'react';
import { Typography } from '../../../Typography/Typography';
import { ComponentStyled } from '../../../ComponentStyled/ComponentStyled';

const ProcessBoxHeader: React.FC = ({ children }) => {

  return (
    <ComponentStyled
      component={Typography}
      componentProps={{
        variant: "subHeadline2",
        component: "h3",
        fontWeight: "bold",
        children: children,
      }}
      marginBottom="24"
    />
  );
};

export { ProcessBoxHeader };
